import { UserDtoModel } from '@heitown/common-dto';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface LoggedUser extends UserDtoModel {}
